import { render, staticRenderFns } from "./pack.vue?vue&type=template&id=137b3878&scoped=true&"
import script from "./pack.vue?vue&type=script&lang=js&"
export * from "./pack.vue?vue&type=script&lang=js&"
import style0 from "./pack.vue?vue&type=style&index=0&id=137b3878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b3878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137b3878')) {
      api.createRecord('137b3878', component.options)
    } else {
      api.reload('137b3878', component.options)
    }
    module.hot.accept("./pack.vue?vue&type=template&id=137b3878&scoped=true&", function () {
      api.rerender('137b3878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/pack/pack.vue"
export default component.exports